import { HEROKU_ID_KEY } from 'types'
import emailsMatch from './emailsMatch'
import shouldResumePostLoginAttach from './shouldResumePostLoginAttach'

// EditMemberContactInfo post-login branch: which account/contact IDs to
// UPDATE, or null to PATCH the guest cart in redux instead.
function resolvePostLoginResumeAttachTarget({
  disableEmail = false,
  savedFormValues = null,
  resumedExistingContact = null,
  userEmail = null,
  cartContactEmail = null,
  prefillAccount = null,
  prefillContact = null,
  prefillMembership = null,
}) {
  if (
    shouldResumePostLoginAttach({
      disableEmail,
      savedFormValues,
      resumedExistingContact,
    })
  ) {
    const trustLookupIds = emailsMatch(
      userEmail,
      savedFormValues?.contact?.email
    )
    const pickId = (lookupKey, prefill) =>
      (trustLookupIds && resumedExistingContact[lookupKey]) ||
      prefill?.[HEROKU_ID_KEY]

    return {
      accountId: pickId('account_hc_ext_id', prefillAccount),
      contactId: pickId('contact_hc_ext_id', prefillContact),
      membershipId: pickId('membership_hc_ext_id', prefillMembership),
    }
  }

  // Stale or missing Sign-in snapshots. Signed-in Edit PATCHes this cart
  // only when it already belongs to the logged-in user. A leftover guest
  // UPDATE (person E) plus sign-in as B must not write B's email onto E —
  // use dashboard prefill, or empty IDs so the caller throws.
  if (disableEmail && !emailsMatch(userEmail, cartContactEmail)) {
    return {
      accountId: prefillAccount?.[HEROKU_ID_KEY],
      contactId: prefillContact?.[HEROKU_ID_KEY],
      membershipId: prefillMembership?.[HEROKU_ID_KEY],
    }
  }

  return null
}

export default resolvePostLoginResumeAttachTarget
